import React, {Component} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faPlus, faPen, faSignInAlt, faCircle, faMicroscope} 
  from '@fortawesome/free-solid-svg-icons'
import {CsvButton5} from './CsvButton3';
import MassEdit from './MassEdit'
import DeviceEdit from './DeviceEdit'

import '../../Overview/overview.css'
import './buttonbar.css'

export default class ButtonBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalShow: false,
      modalOpened: 0,
      deviceModal: false
    };
    this.showAddDevice = this.showAddDevice.bind(this)
    this.deviceEdit = this.deviceEdit.bind(this)
  }
  componentDidMount(){
  }
  componentDidUpdate(prevProps) {

  }

  massEdit (state) {
    this.setState({"modalShow": state})
  }

  deviceEdit (state) {
    if (state?.refresh && this.props.onUpdate)
      this.props.onUpdate()
    this.setState({deviceModal: false})
  }
  showAddDevice () {
    this.setState({deviceModal: true, modalOpened: this.state.modalOpened+1})
  }
  render() {
    const fImport = this.props?.FileImport ?? (()=>{});
    return (
      <div className='button-row2'>
        <span className="fa-stack row-button" onClick={this.props?.details}>
          <FontAwesomeIcon icon={faCircle} color="#E3E2E5" className="fa-stack-2x" />
          <FontAwesomeIcon icon={faMicroscope} color="#257461" className="fa-stack-1x" />
        </span>
        <span className="row-caption">Device details</span>
        <span className="fa-stack row-button" onClick={this.showAddDevice}>
          <FontAwesomeIcon icon={faCircle} color="#E3E2E5" className="fa-stack-2x" />
          <FontAwesomeIcon icon={faPlus} color="#257461" className="fa-stack-1x" />
        </span>
        <span className="row-caption">Commission Device</span>

        {this.props?.onMassEdit ? <>
        <span className="fa-stack row-button" onClick={()=>this.massEdit(true)}>
          <FontAwesomeIcon icon={faCircle} color="#E3E2E5" className="fa-stack-2x" />
          <FontAwesomeIcon icon={faPen} color="#257461" className="fa-stack-1x" />
        </span>
        <span className="row-caption">Mass Edit</span> </>
        : null}
        <span className="fa-stack row-button" onClick={fImport}>
          <FontAwesomeIcon icon={faCircle} color="#E3E2E5" className="fa-stack-2x" />
          <FontAwesomeIcon icon={faSignInAlt} color="#257461" className="fa-stack-1x" />
        </span>
        <span className="row-caption">Import File</span>
        <CsvButton5 {...this.props} />
        <span className="row-caption">Download CSV</span>
        
        <MassEdit show={this.state.modalShow} hide={()=>this.massEdit(false)} count={this.props.massEdit} 
          onChange={this.props.onMassEdit}/>

        <DeviceEdit {...this.props} opened={this.state.modalOpened} show={this.state.deviceModal} onHide={this.deviceEdit} />
      </div>
      );
    }
}
//        <SwapDevice {...this.props} show={this.state.swapModal} onHide={this.swapHide}/>
/*
        <span className="fa-stack row-button" onClick={this.swap}>
          <FontAwesomeIcon icon={faCircle} color="#E3E2E5" className="fa-stack-2x" />
          <FontAwesomeIcon icon={faExchangeAlt} color="#257461" className="fa-stack-1x" />
        </span>
        <span className="row-caption">Swap Device</span>

  swap () {
    this.setState({"swapModal": true})
  }

  swapHide(okCancel, newDevice=undefined, commissioned=undefined) {
    if (okCancel) {
      this.props.onSwap(newDevice, commissioned)
    }
    this.setState({swapModal: false})
  }
     this.swap = this.swap.bind(this);
    this.swapHide = this.swapHide.bind(this)
      swapModal: false,
import SwapDevice from './SwapDevice'
*/